import Vue from 'vue'
import { DateTime } from 'luxon'
import { mapGetters, mapMutations, mapActions } from 'vuex'

const mixins = Vue.mixin({
  computed: {
    ...mapGetters(['progress', 'settings', '_', 'filter', 'favorites', 'timezone', 'local_timezone', 'key']),
  },
  methods: {
    ...mapMutations(['setProgress', 'setBack', 'setUser', 'setModal']),
    ...mapActions(['getSessions', 'getUser']),
    timeZoneOffset(date) {
      const event = DateTime.fromSQL(date, { zone: this.settings.app.event_timezone });
      const local = DateTime.fromSQL(date, { zone: this.local_timezone});
      return local.offset - event.offset;
    },
    formatDay(day) {
      return this._.date_format_program
        .replace('&day', this._[day.day_name])
        .replace('&d', day.day)
        .replace('&month', this._[day.month_name])
        .replace('&y', day.year);
    },
    formatTime(day, time) {
      const offset = this.timeZoneOffset(day.date);
      const options = { timeZone: 'UTC', hour: '2-digit', minute: '2-digit' };
      let stamp = Date.parse('01 Jan 1970 ' + time + ' UTC');
      if (this.timezone === 'local') stamp += (offset * 60000);
      let suffix = '';
      if (stamp < 0) suffix = '<sup>-1</sup>';
      if (stamp > 86400000) suffix = '<sup>+1</sup>';
      return new Date(stamp).toLocaleTimeString([], options) + suffix;
    },
    formatDayTimes(day, start, end) {
      return this.formatDay(day) + ', ' + this.formatTime(day, start) + ' &ndash; ' + this.formatTime(day, end);
    },
    formatTimes(day, start, end) {
      return this.formatTime(day, start) + ' &ndash; ' + this.formatTime(day, end);
    },
    formatPerson(person, area) {
      if (person.country_code && this.settings[area].skip_countries && this.settings[area].skip_countries.split(',').includes(String(person.country_code))) person.country = null;
      let name = '';
      if (this.settings[area].name === 'first-last') name = person.first_name + ' ' + person.last_name;
      if (this.settings[area].name === 'last-first') name = person.last_name + ', ' + person.first_name;
      if (this.settings[area].title === '1') name = person.title ? person.title  + ' ' + name : name;
      const affiliation = [];
      if (this.settings[area].affiliation) {
        this.settings[area].affiliation.split(',').forEach((attribute) => {
          let value = person[attribute];
          if (attribute === 'country' && person[attribute]) value = this._[person[attribute + '_code']];
          if (value) affiliation.push(value);
        });
      }
      const brackets = (this.settings[area].brackets === '1') ? [' (', ')'] : [', ', ''];
      return name + ((affiliation.length) ? brackets[0] + affiliation.join(', ') + brackets[1] : '');
    },
    getLocalizedName(item) {
      if (!item) return '';
      const language = this.settings.program?.language || 'de';
      if (language === 'en' && item.name_en) {
        return item.name_en;
      }
      return item.name;
    },
  }
})

export default mixins
